import { MobileRaiseState } from "./types";

export default function getDefaultState(): MobileRaiseState {
	return {
		mobileRaiseTemplates: [],
		mobileRaises: [],
		iconSets: []
	};
}
